module.exports = __webpack_public_path__ + "img/cliGloss2.845216dc.jpg";